/* src/app/shared/components/header-accounts/header-accounts.component.scss */
list-header {
}
list-header ::ng-deep bfm-account-total {
  background: var(--cds-background-main);
  border: 1px solid var(--cds-border);
  padding: 22px;
  border-radius: 4px;
  margin-bottom: 16px;
  line-height: 2.6 !important;
}
list-header ::ng-deep bfm-account-total .account-total {
  margin: 0 0 13px !important;
}
list-header ::ng-deep bfm-account-total .account-total .amount-container {
  margin: unset !important;
  padding: 6px !important;
}
list-header ::ng-deep bfm-account-total .account-total .amount-container label {
  font-size: 14px !important;
  font-weight: 400;
  color: var(--cds-text-strong);
}
list-header ::ng-deep bfm-account-total .account-total .amount-container:hover {
  cursor: unset !important;
  background-color: unset !important;
}
list-header ::ng-deep bfm-account-total .account-total .amount-container i {
  margin-left: 5px !important;
}
list-header ::ng-deep bfm-account-total .account-total .amount-container h3 {
  font-size: 20px !important;
  font-weight: 600 !important;
}
list-header .default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
list-header .default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
list-header .default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
list-header .default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
list-header .default-flex-column {
  display: flex;
  flex-flow: column;
}
list-header .default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
list-header .rounded-circle {
  border-radius: 50%;
}
list-header ::ng-deep bfm-list-accounts {
  background: var(--cds-background-main);
  border: 1px solid var(--cds-border);
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 10px;
  min-height: 133px;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list {
  align-items: flex-start !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container {
  margin: 0 !important;
  position: relative;
  cursor: unset !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container .rounded-circle {
  align-self: center;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container .rounded-circle img {
  width: 30px !important;
  height: 30px !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container .account-info {
  line-height: 1.7 !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container .account-info .account-number {
  max-width: 155px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container .account-info i {
  font-size: 14px;
  margin-left: 3px;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container .account-info h4 {
  font-weight: 600 !important;
  line-height: 1.7 !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container .account-info .account-name {
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container .account-info .checking-account-blocked-balance {
  font-size: 14px !important;
  color: var(--cds-secondary-500) !important;
  font-weight: 600 !important;
  line-height: 1.7 !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .checking-account-container:hover {
  background-color: unset !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list.selected {
  background-color: none !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list:hover {
  background-color: none !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list .divider {
  border-right: 1px solid var(--cds-background-accent) !important;
}
list-header ::ng-deep bfm-list-accounts .checking-account-list > div:last-of-type {
  align-self: center !important;
}
@media screen and (max-width: 1820px) {
  list-header ::ng-deep bfm-list-accounts {
    padding: 7px 20px !important;
  }
}
::ng-deep .bank-header {
  gap: 60px !important;
}
/*# sourceMappingURL=header-accounts.component.css.map */
